import { render } from "./App.vue?vue&type=template&id=320444a4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/abhinay/React/Vuejs/velzon-vue-v3.0.0/velzon_vue_v3.0.0/Admin/saas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__